export default __webpack_public_path__ + "static/media/bricks-pattern.b9e6a3dd.svg";